import '../../components/helper-modules/entry-base';


$('.moto-list li').click(function () {
  $(this).toggleClass('selected');
});
$('.list-page .form-button').click(() => {
  window.submitListPage();
});



// WEBPACK FOOTER //
// src/entries/list/entry.jsx